module.exports = __webpack_public_path__ + "static/media/salaries.72733441.svg";